import styled from 'styled-components'
import { COLORS } from '../../../../styles/colors'
import { CALENDAR_DIMENSIONS } from '../../constants/constants'

export const StyledCalendarHeader = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding: 12px 24px;
	min-height: ${CALENDAR_DIMENSIONS.HEADER_TEXT_HEIGHT}px;
`

export const NavigationButton = styled.button`
	width: 24px;
	height: 24px;
	display: flex;
	align-items: center;
	justify-content: center;
	background: transparent;
	border: none;
	cursor: pointer;
	padding: 0;
	transition: opacity 0.2s ease;

	&:hover {
		opacity: 0.7;
	}
`

export const HeaderCenter = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 8px;
`

export const ClickableText = styled.span`
	display: inline-flex;
	align-items: center;
	gap: 8px;
	text-transform: capitalize;
	cursor: pointer;
	padding: 4px 8px;
	border-radius: 4px;
	transition: all 0.2s ease;

	& svg {
		display: block;
		margin-top: 2px;
	}

	&:hover {
		color: ${COLORS.main};
		background: ${COLORS.backgroundHover};
		& svg {
			color: ${COLORS.main};
			stroke: ${COLORS.main};
		}
		& svg path,
		& svg line,
		& svg polyline,
		& svg polygon,
		& svg circle,
		& svg rect {
			stroke: ${COLORS.main};
		}
	}
`
